import React, { FC } from 'react';
import cn from 'classnames';
import parseClassnames from '../../../helpers/parseClassnames';
import Text from '../../../Text';
import { DialogContentProps } from '../../types';

export interface BodyProps
  extends Pick<DialogContentProps, 'type' | 'body' | 'dark'> {
  hasMoreElements?: boolean;
}

const Body: FC<BodyProps> = ({ type = 'm', body, dark, hasMoreElements }) => {
  const classes = hasMoreElements
    ? cn('block text-center', type === 'm-form' ? 'mb-24' : 'mb-32', {
        [type === 'm-form' ? 'sm:mb-32' : 'sm:mb-40']: type !== 's',
      })
    : 'block text-center';

  if (typeof body === 'string') {
    return (
      <Text
        className={classes}
        type="body2"
        responsive="sm"
        color={dark ? 'white' : 'base-main'}
      >
        {body}
      </Text>
    );
  }

  const bodyElement = body as React.ReactElement<any>;

  return React.cloneElement(bodyElement, {
    className: parseClassnames(bodyElement.props.className || '', classes),
  });
};

export default Body;
